/**
 * Defines the data that will be broadcasted to other browser tabs.
 */
export abstract class BroadcastEvent<T = unknown> {
  constructor(public payload: T) {}
  abstract type: string;
}
